export enum LightningId {
    // First satisfaction survey
    UserVoiceSatisfactionFirstRun = '0',

    // Second satisfaction survey
    UserVoiceSatisfactionSecondRun = '1',

    // Static Image first-run experience for consumer refresh opt-in
    ConsumerRefreshFRE = '2',

    // Animated first-run experience for consumer refresh opt-in
    AnimatedConsumerRefreshFRE = '3',

    // Animated first-run experience for consumer refresh opt-in
    AnimatedConsumerRefreshFRE2 = '4',

    // Setting panel first run callout
    SettingPanelFirstRunCallout = '5',

    // Setting icon first run callout
    SettingIconFirstRunCallout = '6',

    // Callout for add storage account
    AddStorageAccountCallout = '7',

    // Modal for Premium outlook domain connect experience
    PremiumDomainConnectModal = '8',

    // Open Whats New flex pane on first logon
    WhatsNewFlexPane = '10',

    // Turn off Focus/Other list view button
    FocusOtherOff = '12',

    // Targeted ads GDPR prompt
    TargetedAdsGdprPrompt = '13',

    // Web Push Promotion
    WebPushPromotion = '14',

    // Mail beta graduation new feature carousel
    MailGraduatedNewFeatureCarousel = '15',

    // EdgePromotion banner
    EdgePromotion = '20',

    // Shows Teaching UI on first-view of a new Actionable Message
    ActionableMessageTeachingUiTeachingBubblePolicy = '21',

    // Open Get Started flex pane on first logon
    GetStartedFlexPane = '22',

    // Calendar satisfaction survey
    CalendarSurvey = '23',

    // Enterprise opt-in new feature carousel
    EnterpriseOptInFRE = '24',

    // Mini user survey
    MiniUserSurveyV1 = '25',

    // Todo Calendar FRE
    TodoCalendarFRE = '26',

    // Todo Mail FRE
    TodoMailFRE = '27',

    // FRE for Group files hub
    GroupFilesHubFRE = '28',

    //Teaching UI for adding cloud cache account
    AddCloudCacheAccountCallout = '29',

    // New consumer recruitment campaign
    NewConsumerRecruitmentCampaign = '30',

    // Inbox plus teaching moment
    InboxPlusFRE = '31',

    // Business cut over landing carousel
    BusinessCutoverCarousel = '32',

    // Suite NPS
    SuiteNps = '33',

    // Inbox plus easy on
    InboxPlusEasyOn = '34',

    // Inbox rules from a DL teaching UI
    InboxRulesFromDL = '35',

    // Gdpr Ads V2. Prompt around the end of year 2019 with the new LCA requirement
    GdprAdsV2 = '36',

    // Time Panel combined drag-and-drop FRE
    TimePanelCombinedDndFRE = '47',

    // Privacy notification for UAE
    UaeEduPrivacyNotification = '48',

    // Outlook Spaces (timestream) new space FRE
    OutlookSpacesFRE = '49',

    // Todo Flagged Email List
    TodoFlaggedEmailList = '50',
}
